module.exports = __webpack_public_path__ + "img/WGHN.f2c3bf64.png";